import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FuseConfigService } from '@fuse/services/config';
import { WebColorScheme } from '@libs/shared/api';

@Component({
  selector: 'app-color-scheme-menu-button',
  standalone: true,
  imports: [MatButtonModule, MatMenuModule, MatIconModule],
  template: `
    <button mat-icon-button [matMenuTriggerFor]="menu">
      @if (webColorScheme === 'Auto') {
        <mat-icon
          class="icon-size-5"
          [svgIcon]="'mat_outline:brightness_auto'" />
      }
      @if (webColorScheme === 'Light') {
        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:sun'" />
      }
      @if (webColorScheme === 'Dark') {
        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:moon'" />
      }
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="onSetColorScheme('auto')">
        <mat-icon [svgIcon]="'mat_outline:brightness_auto'" />
        <span>자동</span>
      </button>
      <button mat-menu-item (click)="onSetColorScheme('light')">
        <mat-icon [svgIcon]="'heroicons_solid:sun'" />
        <span>라이트</span>
      </button>
      <button mat-menu-item (click)="onSetColorScheme('dark')">
        <mat-icon [svgIcon]="'heroicons_solid:moon'" />
        <span>다크</span>
      </button>
    </mat-menu>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorSchemeMenuButtonComponent {
  @Input() webColorScheme: WebColorScheme | null;

  @Output() readonly bySetWebColorScheme = new EventEmitter<WebColorScheme>();

  constructor(private _fuseConfigService: FuseConfigService) {}

  onSetColorScheme(scheme: 'auto' | 'dark' | 'light') {
    const colorScheme = this.convertToColorScheme(scheme);
    if (colorScheme === this.webColorScheme) {
      return;
    }
    this.bySetWebColorScheme.emit(colorScheme);
  }

  convertToColorScheme(scheme: 'auto' | 'dark' | 'light') {
    switch (scheme) {
      case 'auto':
        return WebColorScheme.Auto;
      case 'light':
        return WebColorScheme.Light;
      case 'dark':
        return WebColorScheme.Dark;
    }
  }
}
